import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "main", "overlay"]

  open() {
    this.sidebarTarget.classList.remove("max-lg:-translate-x-full")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.add("opacity-30")
  }

  close() {
    this.sidebarTarget.classList.add("max-lg:-translate-x-full")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.remove("opacity-30")
  }
}